/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  AuthResponse,
  AuthenticatePasswordPayload,
  AuthenticateTokenPayload,
  DiscoveryAuthPayload,
  DiscoveryAuthResponse,
  DiscoveryExchangePayload,
  InviteAcceptPayload,
  LoginOrSignupPayload,
  LoginOrSignupResponse,
  OrgCreationPayload,
  OrgEmailSearchPayload,
  PasswordResetCompletePayload,
  PasswordResetPayload,
  PasswordStrengthPayload,
  PasswordStrengthResponse,
  SsoEmailLinkChallengeResponse,
  SsoEmailLinkResendPayload,
  SsoEmailLinkStartPayload,
  SsoEmailLinkVerifyPayload,
  SsoLoginResolutionResponse,
  SuccessMessageResponse,
  SupportMicrosoftAuthenticatePayload,
  SupportMicrosoftStartResponse,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getAuth = () => {
  /**
   * @summary Start Support Microsoft
   */
  const authStartSupportMicrosoft = (
    options?: SecondParameter<
      typeof axiosInstance<SupportMicrosoftStartResponse>
    >
  ) => {
    return axiosInstance<SupportMicrosoftStartResponse>(
      { url: `/auth/support-microsoft/start`, method: 'POST' },
      options
    );
  };
  /**
   * @summary Authenticate Support Microsoft
   */
  const authAuthenticateSupportMicrosoft = (
    supportMicrosoftAuthenticatePayload: SupportMicrosoftAuthenticatePayload,
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      {
        url: `/auth/support-microsoft/authenticate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: supportMicrosoftAuthenticatePayload,
      },
      options
    );
  };
  /**
   * Authenticate user with email and password
   * @summary Authenticate Password
   */
  const authAuthenticatePassword = (
    authenticatePasswordPayload: AuthenticatePasswordPayload,
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      {
        url: `/auth/password`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: authenticatePasswordPayload,
      },
      options
    );
  };
  /**
   * Verify the current authentication token
   * @summary Verify Token
   */
  const authVerifyToken = (
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      { url: `/auth/verify`, method: 'GET' },
      options
    );
  };
  /**
   * Logout by revoking the current session token and the user's MCP OAuth grants
   * @summary Logout
   */
  const authLogout = (
    options?: SecondParameter<typeof axiosInstance<SuccessMessageResponse>>
  ) => {
    return axiosInstance<SuccessMessageResponse>(
      { url: `/auth/logout`, method: 'POST' },
      options
    );
  };
  /**
   * Send password reset email
   * @summary Send Password Reset Email
   */
  const authSendPasswordResetEmail = (
    passwordResetPayload: PasswordResetPayload,
    options?: SecondParameter<typeof axiosInstance<SuccessMessageResponse>>
  ) => {
    return axiosInstance<SuccessMessageResponse>(
      {
        url: `/auth/password_reset`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: passwordResetPayload,
      },
      options
    );
  };
  /**
   * Authenticate user with magic link token
   * @summary Authenticate Magic Link
   */
  const authAuthenticateMagicLink = (
    authenticateTokenPayload: AuthenticateTokenPayload,
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      {
        url: `/auth/token_auth`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: authenticateTokenPayload,
      },
      options
    );
  };
  /**
   * @summary Start Sso Email Link
   */
  const authStartSsoEmailLink = (
    ssoEmailLinkStartPayload: SsoEmailLinkStartPayload,
    options?: SecondParameter<
      typeof axiosInstance<SsoEmailLinkChallengeResponse>
    >
  ) => {
    return axiosInstance<SsoEmailLinkChallengeResponse>(
      {
        url: `/auth/sso-email-link/start`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: ssoEmailLinkStartPayload,
      },
      options
    );
  };
  /**
   * @summary Resend Sso Email Link
   */
  const authResendSsoEmailLink = (
    ssoEmailLinkResendPayload: SsoEmailLinkResendPayload,
    options?: SecondParameter<
      typeof axiosInstance<SsoEmailLinkChallengeResponse>
    >
  ) => {
    return axiosInstance<SsoEmailLinkChallengeResponse>(
      {
        url: `/auth/sso-email-link/resend`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: ssoEmailLinkResendPayload,
      },
      options
    );
  };
  /**
   * @summary Verify Sso Email Link
   */
  const authVerifySsoEmailLink = (
    ssoEmailLinkVerifyPayload: SsoEmailLinkVerifyPayload,
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      {
        url: `/auth/sso-email-link/verify`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: ssoEmailLinkVerifyPayload,
      },
      options
    );
  };
  /**
   * Check password strength
   * @summary Check Password Strength
   */
  const authCheckPasswordStrength = (
    passwordStrengthPayload: PasswordStrengthPayload,
    options?: SecondParameter<typeof axiosInstance<PasswordStrengthResponse>>
  ) => {
    return axiosInstance<PasswordStrengthResponse>(
      {
        url: `/auth/password_strength`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: passwordStrengthPayload,
      },
      options
    );
  };
  /**
   * Authenticate discovery magic link token
   * @summary Discovery Authenticate
   */
  const authDiscoveryAuthenticate = (
    discoveryAuthPayload: DiscoveryAuthPayload,
    options?: SecondParameter<typeof axiosInstance<DiscoveryAuthResponse>>
  ) => {
    return axiosInstance<DiscoveryAuthResponse>(
      {
        url: `/auth/discovery`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: discoveryAuthPayload,
      },
      options
    );
  };
  /**
   * Exchange intermediate session token for full session
   * @summary Discovery Exchange
   */
  const authDiscoveryExchange = (
    discoveryExchangePayload: DiscoveryExchangePayload,
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      {
        url: `/auth/discovery/exchange`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: discoveryExchangePayload,
      },
      options
    );
  };
  /**
   * Complete password reset with new password
   * @summary Complete Password Reset
   */
  const authCompletePasswordReset = (
    passwordResetCompletePayload: PasswordResetCompletePayload,
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      {
        url: `/auth/password_reset/complete`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: passwordResetCompletePayload,
      },
      options
    );
  };
  /**
   * Public domain-existence hint; never disclose matching organization identities.
   * @summary Domain Org Exists
   */
  const authDomainOrgExists = (
    orgEmailSearchPayload: OrgEmailSearchPayload,
    options?: SecondParameter<typeof axiosInstance<boolean>>
  ) => {
    return axiosInstance<boolean>(
      {
        url: `/auth/domain_org_exists`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: orgEmailSearchPayload,
      },
      options
    );
  };
  /**
   * @summary Login Or Signup
   */
  const authLoginOrSignup = (
    loginOrSignupPayload: LoginOrSignupPayload,
    options?: SecondParameter<typeof axiosInstance<LoginOrSignupResponse>>
  ) => {
    return axiosInstance<LoginOrSignupResponse>(
      {
        url: `/auth/login_or_signup`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: loginOrSignupPayload,
      },
      options
    );
  };
  /**
   * Resolve SSO login options for a user's email: a single connection, or a list to pick from.
   * @summary Resolve Sso Login
   */
  const authResolveSsoLogin = (
    orgEmailSearchPayload: OrgEmailSearchPayload,
    options?: SecondParameter<typeof axiosInstance<SsoLoginResolutionResponse>>
  ) => {
    return axiosInstance<SsoLoginResolutionResponse>(
      {
        url: `/auth/resolve_sso_login`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: orgEmailSearchPayload,
      },
      options
    );
  };
  /**
   * @summary Send Discovery Email
   */
  const authSendDiscoveryEmail = (
    loginOrSignupPayload: LoginOrSignupPayload,
    options?: SecondParameter<typeof axiosInstance<void>>
  ) => {
    return axiosInstance<void>(
      {
        url: `/auth/send_discovery_email`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: loginOrSignupPayload,
      },
      options
    );
  };
  /**
   * @summary Finish Invite Acceptance
   */
  const authFinishInviteAcceptance = (
    inviteAcceptPayload: InviteAcceptPayload,
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      {
        url: `/auth/finish_invite_acceptance`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: inviteAcceptPayload,
      },
      options
    );
  };
  /**
   * @summary Finish Account And Org Creation
   */
  const authFinishAccountAndOrgCreation = (
    orgCreationPayload: OrgCreationPayload,
    options?: SecondParameter<typeof axiosInstance<AuthResponse>>
  ) => {
    return axiosInstance<AuthResponse>(
      {
        url: `/auth/finish_account_and_org_creation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: orgCreationPayload,
      },
      options
    );
  };
  return {
    authStartSupportMicrosoft,
    authAuthenticateSupportMicrosoft,
    authAuthenticatePassword,
    authVerifyToken,
    authLogout,
    authSendPasswordResetEmail,
    authAuthenticateMagicLink,
    authStartSsoEmailLink,
    authResendSsoEmailLink,
    authVerifySsoEmailLink,
    authCheckPasswordStrength,
    authDiscoveryAuthenticate,
    authDiscoveryExchange,
    authCompletePasswordReset,
    authDomainOrgExists,
    authLoginOrSignup,
    authResolveSsoLogin,
    authSendDiscoveryEmail,
    authFinishInviteAcceptance,
    authFinishAccountAndOrgCreation,
  };
};
export type AuthStartSupportMicrosoftResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authStartSupportMicrosoft']>>
>;
export type AuthAuthenticateSupportMicrosoftResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getAuth>['authAuthenticateSupportMicrosoft']>
  >
>;
export type AuthAuthenticatePasswordResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authAuthenticatePassword']>>
>;
export type AuthVerifyTokenResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authVerifyToken']>>
>;
export type AuthLogoutResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authLogout']>>
>;
export type AuthSendPasswordResetEmailResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authSendPasswordResetEmail']>>
>;
export type AuthAuthenticateMagicLinkResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authAuthenticateMagicLink']>>
>;
export type AuthStartSsoEmailLinkResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authStartSsoEmailLink']>>
>;
export type AuthResendSsoEmailLinkResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authResendSsoEmailLink']>>
>;
export type AuthVerifySsoEmailLinkResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authVerifySsoEmailLink']>>
>;
export type AuthCheckPasswordStrengthResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authCheckPasswordStrength']>>
>;
export type AuthDiscoveryAuthenticateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authDiscoveryAuthenticate']>>
>;
export type AuthDiscoveryExchangeResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authDiscoveryExchange']>>
>;
export type AuthCompletePasswordResetResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authCompletePasswordReset']>>
>;
export type AuthDomainOrgExistsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authDomainOrgExists']>>
>;
export type AuthLoginOrSignupResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authLoginOrSignup']>>
>;
export type AuthResolveSsoLoginResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authResolveSsoLogin']>>
>;
export type AuthSendDiscoveryEmailResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authSendDiscoveryEmail']>>
>;
export type AuthFinishInviteAcceptanceResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getAuth>['authFinishInviteAcceptance']>>
>;
export type AuthFinishAccountAndOrgCreationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getAuth>['authFinishAccountAndOrgCreation']>
  >
>;
